import { render, staticRenderFns } from "./PerItemPricing.vue?vue&type=template&id=37f6236a&scoped=true&"
import script from "./PerItemPricing.vue?vue&type=script&lang=js&"
export * from "./PerItemPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6236a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f6236a')) {
      api.createRecord('37f6236a', component.options)
    } else {
      api.reload('37f6236a', component.options)
    }
    module.hot.accept("./PerItemPricing.vue?vue&type=template&id=37f6236a&scoped=true&", function () {
      api.rerender('37f6236a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/deliverable/PerItemPricing.vue"
export default component.exports